module.exports = __webpack_public_path__ + "img/214.5385893a.jpg";